import { handleDispatchResult } from '@wajeez-web/core/utils';
import { Server } from '@wajeez-web/core/api-base';
import { store } from '@wajeez-web/stores/base';

import {
  getContentEntityListsLookupsAsync,
  getContentEntityListsDatatableAsync,
  getContentEntityListsByContentEntityIdAsync,
  getContentEntityListItemsAsync,
  createContentEntityListAsync,
  editContentEntityListAsync,
  getContentEntityListByIdAsync,
  setContentEntityListsItemListAsync,
} from './slices';
import { ContentEntityListsActions } from '.';

export const getContentEntityListsLookups = async (
  data: { searchText?: string },
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(getContentEntityListsLookupsAsync(data));

  return handleDispatchResult(res, onSuccess);
};

export const getContentEntityListsDatatable = async (
  data: Server.ContentEntityListDatatable,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(getContentEntityListsDatatableAsync(data));

  return handleDispatchResult(res, onSuccess);
};

export const getContentEntityListsByContentEntityId = async (
  id: string,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(
    getContentEntityListsByContentEntityIdAsync(id)
  );

  return handleDispatchResult(res, onSuccess);
};

export const getContentEntityListItems = async (
  id: number,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(getContentEntityListItemsAsync(id));

  return handleDispatchResult(res, onSuccess);
};

export const createContentEntityList = async (
  data: Server.CreateContentEntityListInput,
  onSuccess?: (res: number) => void | Promise<void>
) => {
  const res = await store.dispatch(createContentEntityListAsync(data));

  return handleDispatchResult(res, onSuccess);
};

export const editContentEntityList = async (
  data: Server.EditContentEntityListInput,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(editContentEntityListAsync(data));

  return handleDispatchResult(res, onSuccess);
};

export const getContentEntityListById = async (
  id: number,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(getContentEntityListByIdAsync(id));

  return handleDispatchResult(res, onSuccess);
};

export const setContentEntityListsItemList = async (
  data: Server.SetContentEntityItemListsInput,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(setContentEntityListsItemListAsync(data));

  return handleDispatchResult(res, onSuccess);
};

export const clearContentEntityListById = async () => {
  store.dispatch(ContentEntityListsActions.clearContentEntityListById());
};

export const clearContentEntityListsByContentEntityId = async () => {
  store.dispatch(
    ContentEntityListsActions.clearContentEntityListsByContentEntityId()
  );
};
